import { STATES } from './states';

export const CUSTOM_INFORMATION_PREFIX = 'information-';

export const ITEM_DEFINITION_CODES = {
  AUTO_INSURANCE: 'auto_insurance',
  DIY_MOVE: 'diy_move',
  DMV: 'dmv',
  FORWARD_MAIL: 'forward_mail',
  HOME_SECURITY: 'home_security',
  HOME_SERVICE: 'home_service',
  HOME_SERVICE_APP: 'tv_internet',
  HUDSON_INSURANCE: 'hudson_insurance',
  INFORMATION: 'information',
  INSURANCE: 'insurance',
  INSURANCE_QUOTE: 'insurance_quote',
  INSURANCE_RETENTION: 'insurance_retention',
  MOVEIQ: 'moveiq',
  MOVE_YOUR_STUFF: 'move_your_stuff',
  RELOCATION_SPECIALISTS: 'relocation_specialists',
  PACKING_SUPPLIES: 'packing_supplies',
  MOVING_CENTER: 'moving_center',
  OFFER: 'offer',
  PROMOTION: 'promotion',
  RECOMMENDED_PROVIDER: 'recommended_provider',
  RED_CROSS: 'red_cross',
  RENTERS_INSURANCE: 'renters_insurance',
  RESIDENT_PORTAL: 'resident_portal',
  SHARE: 'share',
  SMART_HOME_OWN: 'smart_home_own',
  UPDATE_ACCOUNT: 'update_account',
  UTILITY: 'utility',
  CALIFORNIA_CARE: 'california_care',
  BACKUP_GENERATOR: 'backup_generator',
  DUKE_WARRANTY: 'duke_warranty',
};

export const ITEM_DEFINITION_STATES = {
  AUTO_INSURANCE: STATES.STEP_AUTO_INSURANCE,
  DIY_MOVE: STATES.STEP_DIY_MOVE,
  DMV: STATES.STEP_DMV,
  FORWARD_MAIL: STATES.STEP_FORWARD_MAIL_LIST,
  HOME_SECURITY: STATES.STEP_HOME_SECURITY,
  HOME_SERVICE: STATES.STEP_HOME_SERVICES,
  HOME_SERVICE_APP: STATES.STEP_HOME_SERVICES_APP,
  HUDSON_INSURANCE: STATES.STEP_HUDSON_INSURANCE,
  INFORMATION: STATES.STEP_CUSTOM_INFORMATION,
  INSURANCE: STATES.STEP_INSURANCE,
  INSURANCE_QUOTE: STATES.STEP_INSURANCE_QUOTES,
  INSURANCE_RETENTION: STATES.STEP_INSURANCE_RETENTION,
  MOVEIQ: STATES.STEP_MOVEIQ,
  MOVE_YOUR_STUFF: STATES.STEP_MOVE_YOUR_STUFF,
  RELOCATION_SPECIALISTS: STATES.STEP_RELOCATION_SPECIALISTS,
  PACKING_SUPPLIES: STATES.STEP_PACKING_SUPPLIES,
  MOVING_CENTER: STATES.STEP_MOVING_CENTER_FORM,
  OFFER: STATES.STEP_OFFERS,
  PROMOTION: STATES.STEP_PROMOTIONS,
  RECOMMENDED_PROVIDER: STATES.STEP_RECOMMENDED_PROVIDERS,
  RED_CROSS: STATES.STEP_RED_CROSS,
  RENTERS_INSURANCE: STATES.STEP_RENTERS_INSURANCE,
  RESIDENT_PORTAL: STATES.STEP_RESIDENT_PORTAL,
  SHARE: STATES.STEP_SHARE_MOVE_PREVIEW,
  SMART_HOME_OWN: STATES.STEP_SMART_HOME_OWN,
  UPDATE_ACCOUNT: STATES.STEP_UPDATE_ACCOUNTS,
  UTILITY: STATES.STEP_UTILITIES,
  BACKUP_GENERATOR: STATES.STEP_BACKUP_GENERATOR,
  CALIFORNIA_CARE: STATES.STEP_CALIFORNIA_CARE,
  DUKE_WARRANTY: STATES.STEP_DUKE_WARRANTY,
};

export const ITEM_DEFINITION_CODES_TO_STATES = Object.keys(
  ITEM_DEFINITION_CODES
).reduce(
  (obj, key) => ({
    ...obj,
    ...{ [ITEM_DEFINITION_CODES[key]]: ITEM_DEFINITION_STATES[key] },
  }),
  {}
);

export const ITEM_STATES_TO_DEFINITION_CODES = Object.keys(
  ITEM_DEFINITION_STATES
).reduce(
  (obj, key) => ({
    ...obj,
    ...{ [ITEM_DEFINITION_STATES[key]]: ITEM_DEFINITION_CODES[key] },
  }),
  {
    // Because the utilities market step isn't a top level state we need to add
    // it here otherwise it'll be missed in the list.
    [STATES.STEP_UTILITIES_MARKET]: 'utility',
  }
);
